module.exports = __webpack_public_path__ + "static/media/YM09_5.ab240999.jpg";